<template>
  <content-card v-if="isUserInTransaction" class="payment-container-bg" dark>
    <!-- Card Header -->
    <v-card-title class="pa-0 align-baseline">
      <span class="text-h6">{{ tr.title }}</span>
      <span v-if="isShowRawCost" class="caption ml-1">#{{ trId }}</span>
      <v-spacer></v-spacer>
      <span class="ml-auto d-flex align-baseline">
        <!-- <span>{{ Number(tr.amount).toLocaleString() }} THB</span> -->
        <v-btn
          class="ml-3"
          small
          icon
          @click="delTransactionAndReloadTr(trId, tr.title)"
        >
          <v-icon>mdi-trash-can</v-icon>
        </v-btn>
      </span>
    </v-card-title>

    <v-divider></v-divider>
    <div class="caption float-right">
      {{ $d($options.filters.todate(tr.timestamp), "med") }}
    </div>

    <!-- Payment Flow -->
    <div class="mt-6 d-flex align-center justify-center flex-column flex-sm-row">
      <!-- Payer Card -->
      <PaymentUserCard :success="user === tr.payers[0].payer" :name="tr.payers[0].payer" />

      <!-- Arrow and Amount -->
      <div class="arrow-container my-2 mx-2 mx-sm-4" :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }">
        <v-icon :large="$vuetify.breakpoint.smAndUp">
          {{ $vuetify.breakpoint.xsOnly ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
        </v-icon>
        <div class="my-1 mx-2 mx-sm-4 text-h6 font-weight-medium">
          {{ Number(tr.amount).toLocaleString() }} THB
        </div>
        <v-icon :large="$vuetify.breakpoint.smAndUp">
          {{ $vuetify.breakpoint.xsOnly ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
        </v-icon>
      </div>

      <!-- Receiver Card -->
      <PaymentUserCard :success="user === Object.keys(tr.rentersPaid)[0]" :name="Object.keys(tr.rentersPaid)[0]" />
    </div>

    <!-- Slip Image -->
    <v-chip
      v-if="slipImageUrl"
      small
      class="mt-4"
      :href="slipImageUrl"
      target="_blank"
    >
      <v-icon small left>mdi-file-image</v-icon>
      Slip / Receipt
    </v-chip>
  </content-card>
</template>

<script>
import ContentCard from "@/components/ContentCard.vue";
import PaymentUserCard from "./PaymentUserCard.vue";
import { mapActions } from "vuex";
import Group from "@/service/group.js";
import { getLink, deleteFile } from "@/service/storage.js";

export default {
  props: {
    tr: {
      default: {},
    },
    trId: {
      default: "",
    },
    user: {
      default: "",
    },
    isShowRawCost: {
      default: false,
    },
    group: {
      type: Group,
      default: () => ({}),
    },
  },

  components: {
    ContentCard,
    PaymentUserCard
  },

  data: () => ({
    slipImageUrl: "",
  }),

  methods: {
    async delTransactionAndReloadTr(trId, title) {
      if (
        !(await this.appOpenDialog({
          title: this.$t("group.removeThisItem"),
          body: `'${title}'`,
          color: "red",
        }))
      )
        return;
      this.$emit("loading", true);
      if (this.tr.slipImageName) {
        await deleteFile(this.tr.slipImageName);
      }
      await this.group.deleteTransaction(trId);
      this.$emit("loading", false);
      this.$emit("reload");
    },

    ...mapActions(["appOpenDialog"]),
  },

  watch: {
    tr: {
      async handler() {
        this.slipImageUrl = this.tr.slipImageName
          ? await getLink(this.tr.slipImageName)
          : "";
      },
      immediate: true,
    },
  },

  computed: {
    isUserInTransaction() {
      if (!this.user) {
        return true; // Show all transactions when no user is selected
      }
      // Check if user is either the payer or the receiver
      return (
        this.tr.payers[0].payer === this.user || 
        Object.keys(this.tr.rentersPaid)[0] === this.user
      );
    },
  },
};
</script>

<style scoped>
.payment-container-bg {
  background: linear-gradient(135deg, #5370c6 0%, #9760ce 100%);
}

@media (max-width: 960px) {
  .payment-card {
    min-width: 100px;
    padding: 8px !important;
  }
}

.arrow-container {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  position: relative;
}

.v-icon {
  opacity: 0.9;
}
</style> 